/*
 * Copyright 1999-2024 Jagex Ltd.
 */
export const API_URL = window._env_?.API_URL;
export const CPP_SITE = window._env_?.CPP_SITE;
export const SOCIAL_PORTAL_WEBSITE_URL = window._env_?.SOCIAL_PORTAL_WEBSITE_URL;
export const WEBSITE_URL = window._env_?.WEBSITE_URL;
